import { useSelector } from "react-redux";
import { DELIVERY_MODES } from "../../constants/data";
import { formatPrice } from "../../helpers/formatHelper";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { RootState } from "../../store";

interface IDeliveryCostsRowProps {
  totalPrice: number;
}

export const DeliveryCostsRow = ({ totalPrice }: IDeliveryCostsRowProps) => {
  const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);
  const session = useSelector((state: RootState) => state.session.session);

  if (session?.delivery_mode !== DELIVERY_MODES.delivery) {
    return null;
  }

  const previewDeliveryCost =
    session?.delivery_details?.preview_delivery_cost ?? 0;

  const deliveryCost = restaurant?.delivery_cost ?? 0;
  const freeDeliveryMinimum =
    restaurant?.free_delivery_minimum_amount ?? 0;

  const mustApplyDeliveryCost =
    deliveryCost === 0 ||
    freeDeliveryMinimum === 0 ||
    totalPrice < freeDeliveryMinimum;

  const price = mustApplyDeliveryCost
    ? formatPrice(previewDeliveryCost)
    : formatPrice(0);

  return (
    <div className="row recap-item-row">
      <div className="col-2" />
      <div className="col-5 text-left">
        <span className="recap-item-name-label">
          {LocalizerHelper.localized("delivery_cost")}
        </span>
      </div>
      <div className="col-3 text-right">
        <span className="recap-item-price-label">{price}</span>
      </div>
      <div className="col-2" />
    </div>
  );
};
